import '../scss/offers-list.scss';

import '../common';
import sendData from '../components/sendData';
import notifier from '../components/notifier';

document.addEventListener("DOMContentLoaded", function(event) {
  const form = document.getElementById('password_reset_form');


  if (form){
    const submitButton = form.querySelector('button');
    const field = form.querySelector('.form-control');

    submitButton.addEventListener('click', function (event){
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.innerHTML = gettext('Отправляется...');
      sendData('POST', `/${window.lang}/api/users/validate-email/`, new FormData(form))
        .then((response) => {
          if (response.ok){
            field.classList.remove('is-invalid');
            field.classList.add('is-valid');
            form.submit();
          } else{
            field.classList.add('is-invalid');
            form.querySelector('.invalid-feedback').innerHTML = response[0];
            submitButton.removeAttribute('disabled');
            submitButton.innerHTML = gettext('Сбросить пароль');
          }
        })
    });
  }
});